import React, { useCallback } from 'react';
import { includes, without } from 'ramda';
import { withStyles } from '@mui/styles';
import { Typography as Text, TextField } from '@mui/material';
import cx from 'classnames';

// This presence of this value will allow a custom value to be entered
const CUSTOM_FIELD_TRIGGER_VALUE = 'Other';
const CUSTOM_FIELD_MARITAL_STATUS = ['civilpartnership', 'inpartnership', 'stableunion'];

const styles = ({ palette }) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  tag: {
    padding: '4px 9px 4px 9px',
    marginRight: '3px',
    marginBottom: '3px',
    backgroundColor: 'rgb(240,240,240)',
    color: 'grey',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: palette.primary.main,
      color: palette.common.white,
    },
  },
  selected: {
    backgroundColor: palette.primary.main,
    color: palette.primary.contrastText,
    '&:hover': {
      opacity: 0.7,
    },
  },
});

const PickOne = React.memo(function PickOne({ classes, options = [], value: selectedValue, onChange }) {
  const onClick = useCallback(val => () => {
    let newVal = val;
    if (includes(CUSTOM_FIELD_TRIGGER_VALUE, options) && val === CUSTOM_FIELD_TRIGGER_VALUE) {
      newVal = '';
    }
    onChange(newVal);
  }, [onChange, options]);

  const handleChange = useCallback(event => {
    onChange(event.target.value);
  }, [onChange]);

  //Set marital status - based on Arken.Common.dll values and RegisterForm values
  const getSelectedStatus = val => {
    if (CUSTOM_FIELD_MARITAL_STATUS.includes(selectedValue)) {
      if (selectedValue === 'civilpartnership') {
        selectedValue = 'civil partnership';
      } else if (selectedValue === 'inpartnership') {
        selectedValue = 'living as partners';
      } else if (selectedValue === 'stableunion') {
        selectedValue = 'stable union';
      }
    }

    if (
      val === CUSTOM_FIELD_TRIGGER_VALUE &&
      !includes(selectedValue, without(CUSTOM_FIELD_TRIGGER_VALUE, options)) &&
      selectedValue !== null &&
      selectedValue !== undefined
    ) {
      return true;
    }

    if (!includes(selectedValue, options)) {
      return false;
    }

    return val === selectedValue;
  };

  return (
    <>
      <div className={classes.root}>
        {options.map((value, index) => (
          <div
            key={index}
            onClick={onClick(value)}
            role="button"
            className={cx('noselect', classes.tag, {
              [classes.selected]: getSelectedStatus(value),
            })}
          >
            <Text color="inherit" variant="caption">
              {getSelectedStatus(value) && <span>&#10003;</span>}
              {value.toUpperCase()}
            </Text>
          </div>
        ))}
      </div>
      {includes(CUSTOM_FIELD_TRIGGER_VALUE, options) &&
        !includes(selectedValue, without(CUSTOM_FIELD_TRIGGER_VALUE, options)) &&
        selectedValue !== null &&
        selectedValue !== undefined && <TextField value={selectedValue} onChange={handleChange} variant="standard" />}
    </>
  );
});

export default withStyles(styles)(PickOne);
